import styles from "../../../../AccountingPage.module.scss";
import { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { getEmployeeSalaryPayData, StatusChangeSalaryData } from "service/AccountingService";
import Notification from "utils/Notifications";
const EmployeeSalaryHistoryContent = ({ render, setRender, id, dataemployee }) => {
  const componentRef = useRef();
  const groupByYearAndMonth = (data) => {
    return data.reduce((acc, item) => {
      const year = item.year || "Без года";
      const month = item.month || "Без месяца";
      if (!acc[year]) acc[year] = {};
      if (!acc[year][month]) acc[year][month] = [];
      acc[year][month].push(item);
      return acc;
    }, {});
  };


  const [salaryData, setSalaryData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const monthsOrder = [
    "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
    "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
  ];

  // Получить только те месяцы, которые есть в данных, и отсортировать по monthsOrder

  const groupedByYearAndMonth = groupByYearAndMonth(salaryData);
  const years = Object.keys(groupedByYearAndMonth).sort((a, b) => b.localeCompare(a, undefined, { numeric: true }));


  useEffect(() => {
    const fetchSalaryData = async () => {
      try {
        const response = await getEmployeeSalaryPayData(id);
        setSalaryData(response.data);
      } catch (error) {
        console.log("Ошибка получения данных по зарплате сотрудника");
      }
    };
    fetchSalaryData();
    setRender(false);
    // eslint-disable-next-line
  }, [render, id, setRender]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const onStatusChange = async (id) => {
    let data = await StatusChangeSalaryData(id);
    setNotify({
      isOpen: true,
      message: "Статус успешно изменен!",
      type: "success",
      sound: "success"
    });
    setRender(true)
  };
  const totalPages = Math.ceil(salaryData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = salaryData.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <div className={styles.content_header} style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ width: "100%" }} className={styles.print_header_selection_shah}>
          <h3 className={styles.project__h}>Актуальные</h3>
          <hr style={{ borderTop: "2px solid #444", margin: "20px 0 0 0" }} />
          <table className={styles.table__wrapper}>
            <thead className={styles.table__head}>
              <tr className={styles.table__row}>
                <th className={styles.table__item_person}>ИНН</th>
                <th className={styles.table__item_person}>Фамилия</th>
                <th className={styles.table__item_person}>Имя</th>
                <th className={styles.table__item_person}>Подразделение</th>
                <th className={styles.table__item_person}>Должность</th>
                <th className={styles.table__item_person}>Ставка</th>
                <th className={styles.table__item_person}>Статус</th>
                <th className={styles.table__item_person}>Дата и время</th>
              </tr>
            </thead>
            <tbody className={styles.table__body}>
              <tr className={styles.table__row}>
                <td className={styles.table__item_person}>{dataemployee?.personaldata?.inn}</td>
                <td className={styles.table__item_person}>{dataemployee?.personaldata?.surname}</td>
                <td className={styles.table__item_person}>{dataemployee?.personaldata?.first_name}</td>
                <td className={styles.table__item_person}>{dataemployee.department_name}</td>
                <td className={styles.table__item_person}>{dataemployee.posititon_name}</td>
                <td className={styles.table__item_person}>{dataemployee.stavka}</td>
                <td className={styles.table__item_person}>
                  <span
                    className={styles.table__title}
                    style={{
                      fontWeight: "700",
                      padding: "5px",
                      borderRadius: "6px",
                      display: "block",
                      textAlign: "center",
                      background:
                        dataemployee.status === "Работает"
                          ? "#5C5CFF"
                          : dataemployee.status === "Уволен(а)"
                            ? "#a00000ff"
                            : dataemployee.status === "В отпуске"
                              ? "#ec9900ff"
                              : dataemployee.status === "В командировке"
                                ? "#333333"
                                : dataemployee.status === "На больничном"
                                  ? "#0a62a3"
                                  : dataemployee.status === "В декретном отпуске"
                                    ? "#ffb6c1"
                                    : dataemployee.status === "В отпуске без содержания"
                                      ? "#999"
                                      : "transparent",
                      color: dataemployee.status ? "white" : "inherit",
                    }}
                  >
                    {dataemployee.status || ""}
                  </span>
                </td>
                <td className={styles.table__item_person}>
                  {new Date().toLocaleString("ru-RU", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}
                </td>
              </tr>
            </tbody>
          </table>
          <h3 className={styles.project__h}>История выплат</h3>
          <hr style={{ borderTop: "2px solid #444", margin: "20px 0 0 0" }} />
        </div>


        <div ref={componentRef} className={styles.table__wrapper}>
          {years.map((year) => (
            <div key={year}>
              <h3 style={{ margin: "30px 0 10px 0" }}>Год: {year}</h3>
              {monthsOrder.slice().reverse().map((month) => {
                const monthData = groupedByYearAndMonth[year][month];
                if (!monthData || monthData.length === 0) return null;
                // Сумма total_salary за месяц только для статуса "Выплачено"
                const totalSalaryForMonth = monthData
                  .filter(item => item.status === "Выплачено")
                  .reduce((sum, item) => sum + (Number(item.total_salary) || 0), 0);
                return (
                  <div key={month} style={{ marginBottom: "30px" }}>
                    <h4 style={{ margin: "20px 0 10px 0" }}>
                      {month}-{year}:{" "}
                      <span style={{ fontWeight: 400, fontSize: "16px" }}>
                        В сумме выплачено за месяц: <span> {totalSalaryForMonth.toLocaleString("ru-RU")} сом. </span>
                      </span>
                    </h4>
                    <table className={styles.table__wrapper}>
                      <thead className={styles.table__head}>
                        <tr className={styles.table__row}>
                          <th className={styles.table__item_person}>№</th>
                          <th className={styles.table__item_person}>Вид выплаты</th>
                          <th className={styles.table__item_person}>Оклад, сумма</th>
                          <th className={styles.table__item_person}>Удержания(%), сумма</th>
                          <th className={styles.table__item_person}>Надбавки(%), сумма</th>
                          <th className={styles.table__item_person}>Сумма по контракту</th>
                          <th className={styles.table__item_person}>Оплата за час</th>
                          <th className={styles.table__item_person}>Кол-во часов</th>
                          <th className={styles.table__item_person}>Сумма по часовых</th>
                          <th className={styles.table__item_person}>Итоговая сумма</th>
                          <th className={styles.table__item_person}>Статус</th>
                          <th className={styles.table__item_person}>Дата создания</th>
                          <th className={`${styles.table__item_person} ${styles.print_none_class}`}>Действия</th>
                        </tr>
                      </thead>
                      <tbody className={styles.table__body}>
                        {monthData.map((item, index) => (
                          <tr className={styles.table__row} key={item.id}>
                            <td className={styles.table__item_person}>{index + 1}</td>
                            <td className={styles.table__item_person}>{item.payment_type || ""}</td>
                            <td className={styles.table__item_person}>{item.salary_amount || ""}</td>
                            <td className={styles.table__item_person}>{item.deduction_amount || ""}</td>
                            <td className={styles.table__item_person}>{item.allowance_amount || ""}</td>
                            <td className={styles.table__item_person}>{item.contract_amount || ""}</td>
                            <td className={styles.table__item_person}>{item.hourly_rate || ""}</td>
                            <td className={styles.table__item_person}>{item.hours_count || ""}</td>
                            <td className={styles.table__item_person}>{item.hourly_total || ""}</td>
                            <td className={styles.table__item_person} style={{ fontWeight: "700" }}>
                              {item.total_salary || ""}
                            </td>
                            <td className={styles.table__item_person}>
                              <span
                                className={styles.table__title}
                                style={{
                                  fontWeight: "700",
                                  padding: "5px",
                                  borderRadius: "6px",
                                  display: "block",
                                  textAlign: "center",
                                  background:
                                    item.status === "Выплачено"
                                      ? "#5C5CFF"
                                      : item.status === "Отозвано"
                                        ? "#a00000ff"
                                        : "transparent",
                                  color: item.status ? "white" : "inherit",
                                }}
                              >
                                {item.status || "-"}
                              </span>
                            </td>
                            <td className={styles.table__item_person}>{item.created_at}</td>
                            <td className={`${styles.table__item_person} ${styles.print_none_class}`}>
                              {item.status === "Отозвано" ? null : (
                                item.status === "Выплачено" && (
                                  <button
                                    className={styles.table__button}
                                    style={{
                                      fontWeight: "700",
                                      padding: "5px",
                                      borderRadius: "6px",
                                      display: "block",
                                      textAlign: "center",
                                      background: "#5e5e5eff",
                                      color: "white",
                                      border: "none",
                                      cursor: "pointer",
                                      minWidth: "90px"
                                    }}
                                    onClick={() => {
                                      onStatusChange(item.id);
                                    }}
                                  >
                                    Отозвать
                                  </button>
                                )
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                );
              })}
            </div>
          ))}
        </div>

      
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  );
};

export default EmployeeSalaryHistoryContent;